<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://www.isilive.ca/"> iSi Live Webcasting </a>
          </li>
          <li>
            <a :href="ISI_API_URL + 'logout'"> Logout </a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; 2020
        <a href="https://www.isilive.ca/" target="_blank"
          >iSi Live Webcasting</a
        >
      </div>
    </div>
  </footer>
</template>
<script>
import {
  ISI_API_URL,
  ISI_PLAYER_DOMAIN,
  ISI_RTMP_INPUT_DOMAIN,
} from "../../config";
export default {
  data() {
    return {
      ISI_API_URL: ISI_API_URL,
    };
  },
};
</script>
<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 260px; /* Account for sidebar width */
  right: 0;
  background: #f5f5f5;
  border-top: 1px solid #e0e0e0;
  padding: 15px 30px;
  z-index: 100;
  font-size: 12px;
  color: #999;
}

.footer .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: none;
  padding: 0;
}

.footer nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.footer nav ul li {
  margin-right: 25px;
}

.footer nav ul li a {
  color: #999;
  text-decoration: none;
  font-size: 12px;
  transition: all 0.3s;
}

.footer nav ul li a:hover {
  color: #333;
}

.footer .copyright {
  font-size: 12px;
  color: #999;
}

.footer .copyright a {
  color: #999;
  text-decoration: none;
}

.footer .copyright a:hover {
  color: #333;
}

/* Responsive */
@media (max-width: 991px) {
  .footer {
    left: 0;
  }
}
</style>
